module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "reg-box"
  }, [_c('li', {
    staticClass: "errmsg"
  }, [_vm._v("\n            " + _vm._s(_vm.msg) + "\n        ")]), _vm._v(" "), _c('li', [_c('label', [_c('span', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.email),
      expression: "userData.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.userData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.code),
      expression: "userData.code"
    }],
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.userData.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px",
      "width": "120px",
      "background-color": "#AE0D73",
      "color": "#FFF",
      "border": "0",
      "height": "40px",
      "margin-left": "90px",
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.codeFlag == '0'
    },
    on: {
      "click": function($event) {
        _vm.getCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.verifyMsg))])])]), _vm._v(" "), _c('li', [_c('label', [_c('span', [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.pwd),
      expression: "userData.pwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.userData.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "pwd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', [_vm._v("确认新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.cpwd),
      expression: "userData.cpwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "确认新密码"
    },
    domProps: {
      "value": (_vm.userData.cpwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "cpwd", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "reg-btn-box"
  }, [_c('button', {
    on: {
      "click": _vm.doReg
    }
  }, [_vm._v("确认")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../imgs/ico10.png"),
      "alt": ""
    }
  }), _vm._v("重置密码\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-575ae0ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tiantan/resetpass_cn.vue
// module id = 804
// module chunks = 10